import { render } from "./BeneficiaryCard.vue?vue&type=template&id=03036262&ts=true"
import script from "./BeneficiaryCard.vue?vue&type=script&lang=ts"
export * from "./BeneficiaryCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__